const initialState = {
    myProducts: [],
    allProducts: [],
    inputProductName: '',
    categories: [],
    inputCategory: '',

    
    title: '',
    fromDate: '', 
    startTime: '',
    toDate: '', 
    endTime: '',
    branchOptions: [],
    branchSelect: null,
    cashierOptions: [],
    cashierSelect: null,
};

const products = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_PRODUCTS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default products;
